import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Loader from 'components/_UI/Loader';
import ticketsApi from 'api/requests/tickets';
import { Column } from 'styled/alignment/Column';
import SalesPanel from '../../_sales/SalesPanel';

const COPY = {
    soldLabel: 'Ingressos vendidos',
    iconName: 'ticket',
    sectionTitle: 'Desempenho por ingresso',
    sectionSubtitle: 'Quanto cada tipo vendeu, arrecadou e ainda tem em estoque.',
    sortLabel: 'Ordenar ingressos',
    hiddenLabel: 'Ingresso oculto',
    emptyText: 'Nenhum ingresso cadastrado para este evento.',
};

export default function TicketDetail({ data }) {
    const [payload, setPayload] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getEvent(data);
    }, [data]);

    async function getEvent(slug) {
        setIsLoading(true);

        try {
            const { data: response } = await ticketsApi.getTicketForEvent(slug);
            setPayload(response);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    if (isLoading) {
        return (
            <ContentLoader>
                <Loader />
            </ContentLoader>
        );
    }

    const soldOnline = Number(payload?.tickets_sold_online) || 0;
    const soldOffline = Number(payload?.tickets_sold_offline) || 0;
    const revenueOnline = Number(payload?.tickets_revenue_online) || 0;
    const revenueOffline = Number(payload?.tickets_revenue_offline) || 0;

    /* Os cards do topo levam só o online. Venda no PDV não tem lote, então
       somá-la aqui fazia o card divergir da lista de desempenho logo abaixo:
       o produtor conferia lote a lote e sempre faltava dinheiro. O presencial
       e o total geral aparecem em bloco próprio dentro do SalesPanel. */
    return (
        <SalesPanel
            items={payload?.tickets || []}
            copy={COPY}
            totals={{
                sold: soldOnline,
                total: payload?.tickets_total,
                revenueSold: revenueOnline,
                revenuePotential: payload?.tickets_revenue_total,
            }}
            channels={{ soldOnline, soldOffline, revenueOnline, revenueOffline }}
        />
    );
}

const ContentLoader = styled(Column)`
    min-height: 320px;
    display: flex;
    justify-content: center;
    align-items: center;
`;
